import {CssBaseline, MetrikaProvider, ThemeProvider} from '@logistics-frontend/blocks'
import {Loader} from '@logistics-frontend/blocks/lpc/map'
import {theme} from '@logistics-frontend/blocks/lpc/theme'
import {ThemeProviderv2} from '@logistics-frontend/blocks/v2'
import {I18nProvider} from '@logistics-frontend/core/i18n'
import translate from '@logistics-frontend/core/i18n/translate'
import {ErrorBoundary} from '@logistics-frontend/modules/rum'
import MuiCssBaseline from '@material-ui/core/CssBaseline'
import MuiThemeProvider from '@material-ui/styles/ThemeProvider'
import Logger from '@yandex-int/error-counter/dist/logger'
import {createAuthProxyAPI} from '@yandex-taxi/js-integration-api'
import {IntegrationApiProvider} from '@yandex-taxi/react-integration-api'
import React, {useEffect, useState} from 'react'
import {HelmetProvider} from 'react-helmet-async'
import {BrowserRouter} from 'react-router-dom'

import {client} from './api.client'
import {App} from './components'
import {MAP_QUERY} from './components/consts'
import {MapBoundsProvider} from './components/map-bounds'
import {NotificationsProvider} from './components/notifications'
import {AppConfig, ConfigProvider} from './config'
import {__CONFIG_NAME__, __INT_API_NAME__, __STYLE_ROOT__} from './config/consts'
import {IntegrationApiState} from './config/types'
import {fullValidate} from './validate'

/** @deprecated */
const logger = new Logger()

const Page: React.FC = () => {
  const [{config, intApiState, t, startAuthorization}] = useState(() => {
    const config: AppConfig = window[__CONFIG_NAME__]
    const intApiState: IntegrationApiState = window[__INT_API_NAME__]
    const t = translate(config.lang, config.i18n, 'order')
    const startAuthorization = createAuthProxyAPI({
      host: config.yaAuthProxy.host,
      path: 'integration/turboapp/v1',
      applicationDetectionRules: {
        'X-Taxi': 'yandex.delivery',
      },
      urls: {
        preOrder: '4.0/preorder/v1/availability',
      },
      client,
    })

    logger.initErrors({
      project: 'logistics-frontend-order',
      env: config.env as Ya.Rum.LogEnvironment,
      yandexuid: config.user.yandexUID,
      additional: {
        client_id: config.user.yandexLogin,
      },
    })

    return {
      config,
      intApiState,
      startAuthorization,
      t,
    }
  })

  useEffect(() => {
    const jssStyles = document.querySelector(`#${__STYLE_ROOT__}`)

    jssStyles?.parentElement?.removeChild(jssStyles)
  }, [])

  return (
    <HelmetProvider>
      <BrowserRouter basename="/order">
        <ThemeProviderv2 dir="ltr" locale={config.lang}>
          {__UPCOMING_ORDER_APP__ ? (
            <ThemeProvider>
              <CssBaseline />
              <I18nProvider t={t}>
                <ErrorBoundary>
                  <ConfigProvider config={config}>
                    <MetrikaProvider googleLink={config.googleLink} yandexID={config.yaMetrikaID}>
                      <IntegrationApiProvider
                        apiInstance={startAuthorization}
                        initialState={intApiState}
                        validate={fullValidate(t)}
                      >
                        <NotificationsProvider>
                          <App />
                        </NotificationsProvider>
                      </IntegrationApiProvider>
                    </MetrikaProvider>
                  </ConfigProvider>
                </ErrorBoundary>
              </I18nProvider>
            </ThemeProvider>
          ) : (
            <MuiThemeProvider theme={theme}>
              <MuiCssBaseline />
              <I18nProvider t={t}>
                <ErrorBoundary>
                  <ConfigProvider config={config}>
                    <Loader query={MAP_QUERY}>
                      <MetrikaProvider googleLink={config.googleLink} yandexID={config.yaMetrikaID}>
                        <IntegrationApiProvider
                          apiInstance={startAuthorization}
                          initialState={intApiState}
                          validate={fullValidate(t)}
                        >
                          <MapBoundsProvider>
                            <NotificationsProvider>
                              <App />
                            </NotificationsProvider>
                          </MapBoundsProvider>
                        </IntegrationApiProvider>
                      </MetrikaProvider>
                    </Loader>
                  </ConfigProvider>
                </ErrorBoundary>
              </I18nProvider>
            </MuiThemeProvider>
          )}
        </ThemeProviderv2>
      </BrowserRouter>
    </HelmetProvider>
  )
}

export default Page
